import { makeStyles } from "@material-ui/styles";

export const useStyles = makeStyles({
    loading: {
        height: "calc(100vh - 65px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
});

export const styles = {
    confirmDialog: {
        maxWidth: "460px",
    },
};
